import { Adapter as r } from "../../../../adapter.js";
import { KioskConfigurationDisabledModel as s } from "./kioskConfigurationDisabled.model.js";
class t extends r {
  adapt(e) {
    var i, o;
    return new s({
      texts: (e == null ? void 0 : e.text) ?? {},
      design: {
        images: {
          disabled: (o = (i = e == null ? void 0 : e.design) == null ? void 0 : i.images) == null ? void 0 : o.disabled
        }
      }
    });
  }
  serialize(e) {
    throw new Error("Method not implemented.");
  }
}
export {
  t as KioskConfigurationDisabledAdapter
};
//# sourceMappingURL=kioskConfigurationDisabled.adapter.js.map
